import React from "react";
import { findArray } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const CurrentCompetitor = ({ competitor, routine }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();

    let scoreNeeded = findArray(competitor?.extendedResults, { er_code: ['STAGE'] })?.extensions
    let firstRoutine = findArray(competitor?.extendedResults, { er_code: ['ROUTINE'], er_pos: ['1'] })

    if (breakPoint === 'sm' || breakPoint === 'xs') {
        return (
            <>
                {competitor &&
                    <>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="w-60 align-middle" scope="col"><Label data={'LabelCurrComp'} /></th>
                                    {routine === '2' && <th className="w-10 text-end" scope="col"><Label data={'HeaderExercise1'} sport={mirs_discipline} /></th>}
                                    {routine === '2' && <th className="w-10 text-end" scope="col"><Label data={'HeaderCurrentRank'} sport={mirs_discipline} /></th>}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td ><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                    {routine === '2' && <td className='text-end' >{firstRoutine?.er_value}</td>}
                                    {routine === '2' && <td className='text-end' >{competitor?.resultRank}</td>}
                                </tr>
                            </tbody>
                        </table>
                    </>
                }
            </>
        )
    }
    else {
        return (
            <>
                {competitor &&
                    <>
                        <div className="fw-bold"><Label data={'LabelCurrComp'} /></div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="w-5 text-end" scope="col"><Label data={'LabelStartOrder'} /></th>
                                    <th className="w-60" scope="col"><Label data={'HeaderName'} /></th>
                                    {routine === '2' && <th className="w-10 text-center" scope="col"><Label data={'HeaderExercise1'} sport={mirs_discipline} /></th>}
                                    {routine === '2' && <th className="w-10 text-center" scope="col"><Label data={'HeaderCurrentRank'} sport={mirs_discipline} /></th>}
                                    <th className="w-10 text-end" scope="col"><Label data={'HeaderScoreNeeded'} /></th>
                                    <th className="w-5" scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='text-end' rowSpan={scoreNeeded?.length + 1}>{competitor?.startSortOrder}</td>
                                    <td rowSpan={scoreNeeded?.length + 1}><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                    {routine === '2' && <td className='text-center' rowSpan={scoreNeeded?.length + 1}>{firstRoutine?.er_value}</td>}
                                    {routine === '2' && <td className='text-center' rowSpan={scoreNeeded?.length + 1}>{competitor?.resultRank}</td>}
                                </tr>
                                {scoreNeeded?.map((n, index) => {
                                    return (
                                        <tr key={`score-needed-${index}`}>
                                            <td className="fw-bold"><Label data={'HeaderRank'} sport={mirs_discipline} /> {n.ere_pos}:</td>
                                            <td className="text-end">{n.ere_value}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </>
                }
            </>
        )
    }

}

export default CurrentCompetitor;